export const DRAG_AUTO_SCROLL_EDGE_THRESHOLD_PX = 60;
export const DRAG_AUTO_SCROLL_COLUMN_EDGE_THRESHOLD_PX = 60;
export const DRAG_AUTO_SCROLL_COLUMN_MAX_SPEED_PX = 9;
export const DRAG_AUTO_SCROLL_MAX_SPEED_PX = 18;
export const DRAG_AUTO_SCROLL_ZERO_SPEED = 0;

const CLAMP_MIN = 0;
const CLAMP_MAX = 1;

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

export function computeDragAutoScrollSpeed(
  nearStartDist: number,
  nearEndDist: number,
  edgeThreshold: number,
  maxSpeed: number,
): number {
  if (nearStartDist < edgeThreshold) {
    const factor = clamp(
      1 - nearStartDist / edgeThreshold,
      CLAMP_MIN,
      CLAMP_MAX,
    );
    return -maxSpeed * factor;
  }

  if (nearEndDist < edgeThreshold) {
    const factor = clamp(1 - nearEndDist / edgeThreshold, CLAMP_MIN, CLAMP_MAX);
    return maxSpeed * factor;
  }

  return DRAG_AUTO_SCROLL_ZERO_SPEED;
}
